import * as React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import attempt from 'lodash/attempt';
import get from 'lodash/get';
import { isValidMobileNumber } from 'utils/validators';
import StringWidget from 'components/StringWidget';
import MessageContainer from './LoginViews/MessageContainer';
import SignUpView from './LoginViews/SignUpView';
import LoginView from './LoginViews/LoginView';
import LoginVerificationView from './LoginViews/LoginVerificationView';
import LoginWithOTPView from './LoginViews/LoginWithOTPView';
import { trackLoginSignupActions, getOmnitureLoginId } from './LoginSignupAnalytics';
import fdpHelper from 'utils/FDPHelper';
import { showLoginErrorToast } from 'utils/LoginUtils/smartLoginHelper';
import { withToast } from 'components/Toast/Toast';
import { LoginViews } from './LoginTypes';
import { LOGIN_COMPACT_VIEW, LOGIN_CHECKOUT_VIEW } from 'constants/LoginConstants';
import styles from './LoginSignupWidget.css';
export class LoginSignupView extends React.Component {
    constructor(props) {
        super(props);
        this.trackFDP = (loginParams) => {
            fdpHelper.trackEvent({
                en: 'LRE',
                erc: loginParams.errorCode,
                iss: loginParams.isSuccess,
                lid: loginParams.loginId,
                fid: 'WEBSITE-LOGIN'
            }, true);
        };
        this.handleAPIRequest = (callbackFn, args, successHandler, errorHandler, successTrackingId, errorTrackingId, loginId) => {
            const dispatcher = this.props.dispatch(callbackFn(args));
            const { pageType, loginSource } = this.props;
            const omnitureLoginId = (args && typeof args === 'object' && args.loginId) || loginId;
            if (successHandler && errorHandler) {
                dispatcher.then(json => {
                    successTrackingId &&
                        this.trackOmniture(successTrackingId, {
                            pageType,
                            loginSource,
                            loginId: getOmnitureLoginId(omnitureLoginId)
                        });
                    this.trackFDP({ errorCode: null, isSuccess: true, loginId: omnitureLoginId });
                    return successHandler(json);
                }, err => {
                    errorTrackingId &&
                        this.trackOmniture(errorTrackingId, {
                            pageType,
                            loginSource,
                            loginId: getOmnitureLoginId(omnitureLoginId)
                        });
                    const statusCode = get(err, ['error', 'statuscode'], null);
                    this.trackFDP({ errorCode: statusCode, isSuccess: false, loginId: omnitureLoginId });
                    return errorHandler(err);
                });
            }
        };
        this.handleAPIError = (payload, errorTrackingStr) => showLoginErrorToast(payload, this.props.toast, errorTrackingStr);
        this.changeViewTo = (state, e) => {
            const { pageType, loginSource } = this.props;
            const trackingStr = state.view === LoginViews.SIGNUP ? 'show_signup_popup' : 'show_login_popup';
            if (state.view !== LoginViews.VERIFICATION &&
                state.view !== LoginViews.LOGIN_WITH_OTP &&
                pageType !== LOGIN_CHECKOUT_VIEW) {
                this.trackOmniture(trackingStr, {
                    pageType,
                    loginSource
                });
            }
            this.setState(state);
            e && e.preventDefault();
            return false;
        };
        this.handleLoginSuccess = () => {
            const { onLoginSuccess } = this.props;
            if (typeof onLoginSuccess === 'function') {
                onLoginSuccess();
            }
            else {
                window.location.reload();
            }
        };
        this.trackOmniture = (actionType, trackingData) => {
            attempt(this.props.omnitureTrackingHelper, actionType, trackingData);
        };
        this.state = {
            view: props.view || LoginViews.LOGIN,
            extra: {}
        };
    }
    componentDidMount() {
        const { pageType = '', loginSource = '' } = this.props;
        if (pageType === LOGIN_CHECKOUT_VIEW) {
            // For checkout don't trigger popup omniture action calls. It's already handled in checkout pageload calls.
            return;
        }
        const customLinkName = this.props.view === LoginViews.SIGNUP ? 'Signup Displayed' : 'Login Displayed';
        trackLoginSignupActions('custom', {
            prop21: this.props.view === LoginViews.SIGNUP
                ? `${pageType}_${loginSource} Signup:Displayed`
                : `${pageType}_${loginSource} Login:Displayed`,
            events: 'event12'
        }, customLinkName);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        return this.setState({
            view: nextProps.view || '',
            extra: {}
        });
    }
    render() {
        const { view, extra = {} } = this.state;
        const { toast, viewType = '', overrideStyles, titleKey, descKey, pageType, loginSource, className } = this.props;
        const defaultStyles = Object.assign({}, styles, overrideStyles);
        const signUpView = get(this.state, ['extra', 'signup']);
        const reactivateView = get(this.state, ['extra', 'reactivate']);
        const loginTitleKey = titleKey || (signUpView || view === 'signup' ? 'signupTitleTxt' : 'loginTitleTxt');
        const compactView = viewType === LOGIN_COMPACT_VIEW;
        const childrenProps = {
            handleAPIError: this.handleAPIError,
            handleAPIRequest: this.handleAPIRequest,
            extra,
            viewType,
            changeViewHandler: this.changeViewTo,
            toast,
            trackOmniture: this.trackOmniture,
            compactView,
            styles: defaultStyles,
            handleLoginSuccess: this.handleLoginSuccess,
            pageType,
            loginSource
        };
        const getView = () => {
            switch (view) {
                case LoginViews.MESSAGE_INFO:
                    return <MessageContainer message={get(this.state, ['extra', 'message'])} styles={defaultStyles}/>;
                case LoginViews.SIGNUP:
                    return <SignUpView {...childrenProps}/>;
                case LoginViews.VERIFICATION:
                    return <LoginVerificationView {...childrenProps}/>;
                case LoginViews.LOGIN_WITH_OTP:
                    return <LoginWithOTPView {...childrenProps}/>;
                default:
                    return <LoginView {...childrenProps}/>;
            }
        };
        if (compactView && pageType === LOGIN_CHECKOUT_VIEW) {
            return <div className={defaultStyles['form-view-container']}>{getView()}</div>;
        }
        const description = signUpView || view === LoginViews.SIGNUP
            ? 'signupDesc'
            : extra.unverified
                ? isValidMobileNumber(extra.userName)
                    ? 'verifyMobileDesc'
                    : 'verifyEmailDesc'
                : reactivateView
                    ? 'reactivateDesc'
                    : 'loginDesc';
        return (<div className={cx(defaultStyles['login-widget'], 'row', className)}>
				<div className={cx(defaultStyles['left-container'], 'col', 'col-2-5', styles['login-img'], this.props.leftContainerClass)}>
					<span className={defaultStyles['title']}>
						<StringWidget strKey={loginTitleKey}/>
					</span>
					<p className={defaultStyles['description']}>
						<StringWidget strKey={descKey || description}/>
					</p>
				</div>
				<div className={cx(defaultStyles['form-view-container'], 'col', 'col-3-5')}>
					<div className={defaultStyles['form-wrapper']}>{getView()}</div>
				</div>
			</div>);
    }
}
LoginSignupView.defaultProps = {
    viewType: '',
    omnitureTrackingHelper: trackLoginSignupActions
};
export default connect()(withToast(LoginSignupView));
